<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <!--当前校区-->
    <!--<div style="width: auto;height: 100%;display: flex;flex-direction: row;justify-content: flex-start;align-items: center;flex-grow: 1;">-->
      <!--<label style="margin: 10px 10px 10px 30px;">校区: </label>-->
      <!--<el-radio-group v-model="schoolId" size="mini">-->
        <!--<el-radio-button v-for="item in schools" :label="item.id">{{item.name}}</el-radio-button>-->
      <!--</el-radio-group>-->
    <!--</div>-->
    <!--点击头像下拉选项-->


    <div class="flexRSC" v-if="isSystemManager">
      <span>开发模式：</span>
      <el-switch v-model="devMode" class="drawer-switch" />
    </div>



    <div class="right-menu">

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/profile/index">
            <el-dropdown-item>Profile</el-dropdown-item>
          </router-link>
          <router-link to="/">
            <el-dropdown-item>Dashboard</el-dropdown-item>
          </router-link>
          <a target="_blank" href="https://github.com/PanJiaChen/vue-element-admin/">
            <el-dropdown-item>Github</el-dropdown-item>
          </a>
          <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
            <el-dropdown-item>Docs</el-dropdown-item>
          </a>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">Log Out</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>


  </el-menu>

</template>

<script>
  import {mapGetters} from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'
  import store from "@/store";
  import {SET_DEV_MODE} from "@/store/mutation-types";

  export default {
  data(){
    return {
      device:'web'
    }
  },
  created(){
  },
  mounted(){
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    isSystemManager(){
      return store.getters.isSystemManager
    },
    devMode: {
      get() {
        return store.getters.devMode
      },
      set(value) {
        store.commit("permission/SET_DEV_MODE", value)
      }
    },
    schoolId:{
      get(){
        console.log("get schoolId");
        return this.$store.state.app.schoolId
      },
      set(value){
        console.log("set schoolId:"+value);

        // this.$store.state.app.schoolId = value
        this.$store.commit('SET_SCHOOL_ID',value)
      }

    },
    ...mapGetters([
      'sidebar',
      'avatar',
      'Schools.wpy',
      'cur_school_id'
    ]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

  .school{
    display: inline-block;
    height: 50px;
    line-height: 50px;
    position: absolute;
    right: 170px;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue